import { useCallback } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import MediaSection from './components/MediaSection';
import TopicsSection from './components/TopicsSection';
import CardsSection from './components/CardsSection';
import IndexSection from './components/IndexSection';
import AboutSection from './components/AboutSection';
import UpdatesSection from './components/UpdatesSection';
import ContactSection from './components/ContactSection';
import AppSection from './components/AppSection';
import CarouselSection from './components/CarouselSection';
import FeaturesSection from './components/FeaturesSection';
import FaqSection from './components/FaqSection';
import CommentsSection from './components/CommentsSection';
import RankingSection from './components/RankingSection';
import Footer from './components/Footer';

export default function Home() {
  const handleNavClick = useCallback((id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <Header onNavClick={handleNavClick} />

      <main>
        <Hero />
        <MediaSection />
        <TopicsSection />
        <CardsSection />
        <IndexSection />
        <AboutSection />
        <UpdatesSection />
        <ContactSection />
        <AppSection />
        <CarouselSection />
        <FeaturesSection />
        <FaqSection />
        <CommentsSection />
        <RankingSection />
      </main>

      <Footer />
    </div>
  );
}